var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4"},[_c('button',{staticClass:"relative flex items-center justify-center w-10 h-10 p-0 my-2 rounded-lg text-slate-600 dark:text-slate-100 hover:bg-slate-25 dark:hover:bg-slate-700 dark:hover:text-slate-100 hover:text-slate-600",class:{
      'bg-woot-50 dark:bg-slate-800 text-woot-500 hover:bg-woot-50':
        _vm.isNotificationPanelActive,
    },on:{"click":_vm.openNotificationPanel}},[_c('fluent-icon',{class:{
        'text-woot-500': _vm.isNotificationPanelActive,
      },attrs:{"icon":"alert"}}),_vm._v(" "),(_vm.unreadCount)?_c('span',{staticClass:"text-black-900 bg-yellow-300 absolute -top-0.5 -right-1 text-xxs min-w-[1rem] rounded-full"},[_vm._v("\n      "+_vm._s(_vm.unreadCount)+"\n    ")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }